module.exports = __webpack_public_path__ + "static/the-cost-of-hope-887d058a975db524e0cbc01850a136e2.jpg";